import React from 'react';

export default <g transform="translate(-8.000000, -8.000000)">
    <g id="Asset-Artboard-Page" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="button/video-chat/set-up/audio">
            <g id="icon/record/white" transform="translate(11.000000, 11.000000)" fill="#FFFFFF" fillRule="nonzero">
                <path
                    d="M10.50625,3 L1.49375,3 C0.66875,3 0,3.66875 0,4.49375 L0,13.50625 C0,14.33125 0.66875,15 1.49375,15 L10.50625,15 C11.33125,15 12,14.33125 12,13.50625 L12,4.49375 C12,3.66875 11.33125,3 10.50625,3 Z M16.425,4.178125 L13,6.54062505 L13,11.4593752 L16.425,13.8187502 C17.0875,14.2750002 18,13.8093752 18,13.0125002 L18,4.98437502 C18,4.190625 17.090625,3.72187499 16.425,4.178125 Z"
                    id="Shape"></path>
            </g>
        </g>
    </g>
</g>

